import React from 'react';
import AbstractWidget from './AbstractWidget';
import { Typography } from 'material-ui';
import styles from './PopUpImageWidget.css';
import { getLabels } from '../cmsLib';

class PopUpImageWidget extends AbstractWidget {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    getPosition(labels, type) {
        if (labels) {
            let pos = labels[type].key;
            if (pos.indexOf('upper') !== -1) {
                return 'top';
            }
            if (pos.indexOf('lower') !== -1) {
                return 'bottom';
            }
        }
        return 'middle';
    }

    getLabelObject(labels) {
        let lbo = {
            position: 'middle'
        };
        labels.map(l => {
            lbo[l.key.replace('.', '_')] = l.value;
            if (l.key === 'upperHeader.text') {
                lbo.position = 'top';
            }
            if (l.key === 'lowerHeader.text') {
                lbo.position = 'bottom';
            }
            if (l.key === 'middleHeader.text') {
                lbo.position = 'middle';
            }
        });
        return lbo;
    }

    render() {
        const { widget, className } = this.props;
        let subTitle = getLabels(widget.labels, 'detail.text');
        return (widget ?
            <div className={'cmsPopUpImageWidget ' + (className ? className : '')}>
                <div className="content">
                    <div>
                        <img src={widget.image.url} alt='Some alternative text' />
                    </div>
                    <div>{subTitle ? <Typography dangerouslySetInnerHTML={{ __html: subTitle }}></Typography> : ''}</div>
                </div>
            </div >
            : ''
        );
    }
}

export default (PopUpImageWidget);


// WEBPACK FOOTER //
// ./src/cms/widgets/PopUpImageWidget.js